import { useEffect, useState } from "react";
import API from "../../../services/api";
import "./inventory.css";

export default function InventoryDashboard() {
  const school = JSON.parse(localStorage.getItem("schoolAdmin"))?.school;

  const [stats, setStats] = useState({
    total_items: 0,
    total_categories: 0,
    total_value: 0,
    low_stock: 0,
  });

  const loadStats = async () => {
    try {
      const res = await API.get("/school-admin/inventory/stats/", {
        headers: { "X-SCHOOL-ID": school.id },
      });
      setStats(res.data);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    loadStats();
  }, []);

  return (
    <div className="inventory-dashboard">

      <h2 className="inv-title">Inventory Overview</h2>
      <p className="inv-sub">Track school items, purchases & stock levels.</p>

      <div className="inv-stats-grid">
        
        <div className="inv-card purple">
          <h3>Total Items</h3>
          <p>{stats.total_items}</p>
        </div>

        <div className="inv-card blue">
          <h3>Total Categories</h3>
          <p>{stats.total_categories}</p>
        </div>

        <div className="inv-card green">
          <h3>Total Purchase Value</h3>
          <p>₹{stats.total_value}</p>
        </div>

        <div className="inv-card red">
          <h3>Low Stock Alerts</h3>
          <p>{stats.low_stock}</p>
        </div>

      </div>
    </div>
  );
}